import React from "react";
import Context from "../../../Context";
import EssenceActionsDropdown from "../../Essence/EssenceActionsDropdown";
import EssenceStateLabel from "../../Essence/EssenceStateLabel";
import Blocker from "../../Misc/Blocker";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import DefaultNotFound from "../../Misc/DefaultNotFound";
import Select from "react-select";
import SuperSelect from "../../Misc/SuperSelect";
import FormLine from "../../Misc/FormLine";
import EssenceReference from "../../Essence/EssenceReference";
import EssenceReferenceCisternEdit from "../../Essence/EssenceReferenceCisternEdit";

export default class BunkerOrder extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      item: {},
      lines: [],
      currency: [],
      cisterns: {},

      elementPickIdx: false,
      elementPickShow: false,
    };
  }

  componentDidMount() {
    this.loadReferences().then(() => this.load());
    this.renderButtons();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.docId !== this.props.docId) {
      this.load();
    }
    this.renderButtons();
  }

  onChange = (id, value) => {
    this.setState((state) => {
      let { item } = state;
      item[id] = value;
      return { item };
    });
  };

  onLineChange = (idx, key, value) => {
    let { lines } = this.state;
    lines[idx][key] = value;
    this.setState({ lines });
  };

  loadReferences = async () => {
    this.setState({ pending: true });
    let currency = await this.context.api.qr("/currency/list");
    let cisterns = await this.context.api.qo("/cistern/list");
    this.setState({ pending: false, currency, cisterns });
  };

  rowAdd = (idx) => {
    let { lines } = this.state;
    let index = idx || lines.length;
    lines.splice(index, 0, {});
    this.setState({ lines });
  };

  rowRemove = (idx) => {
    let { lines } = this.state;
    lines.splice(idx, 1);
    this.setState({ lines });
  };

  load = async () => {
    const { docId } = this.props;
    this.setState({ pending: true, notFound: false });
    if (docId && docId !== "add") {
      let item = await this.context.api.q("/bunker/get", { id: docId });
      if (!item) {
        this.setState({ notFound: true });
      } else {
        let lines = await this.context.api.qa("/bunker/item/list", {
          filter: { documentid: docId },
          orderby: ["itemid ASC"],
        });

        this.setState({ item, lines: lines || [] });
      }
    } else {
      let item = {};
      let lines = [];
      let searchParams = new URLSearchParams(
        this.props.location.search.substr(1)
      );

      let append = searchParams.get("append");
      if (append) {
        let appendItems = append.split(",");
        appendItems.forEach((id) => {
          lines.push({ cisternid: id });
        });
      }

      let ship = searchParams.get("ship");
      if (append) {
        item.ship = ship;
      }

      this.setState({ item, lines });
    }
    this.setState({ pending: false });
    this.context.force();
  };

  save = async () => {
    let docId = null;
    if (this.props.docId && this.props.docId !== "add") {
      docId = this.props.docId;
    }

    const { item } = this.state;
    this.setState({ pending: true });
    let saveData = {
      id: docId,
      description: item.description,
      ship: item.ship,
      harbor: item.harbor,
    };
    let result = await this.context.api.q("/bunker/set", saveData);

    if (result !== false) {
      let items = [];
      let { lines } = this.state;
      lines.forEach((line) => {
        items.push({
          cisternid: line.cisternid,
          volume: line.volume,
          price: line.price,
          currencyid: line.currencyid,
        });
      });

      let itemsResult = await this.context.api.q("/bunker/item", {
        items,
        document: result.id,
      });
      if (itemsResult !== false) {
        this.context.toast("Изменения сохранены", "success");
      } else {
        this.context.toast("Не удалось сохранить изменения", "error");
      }

      if (this.props.docId === "add") {
        this.setState({ pending: false });
        this.context.redirect(`/bunkerorder/${result.id}`);
      } else {
        this.load();
      }
    } else {
      this.setState({ pending: false });
      this.context.toast("Не удалось сохранить изменения", "error");
    }
  };

  new = () => {
    this.setState({ lines: [] });
    this.context.redirect("/bunkerorder/add");
  };

  open = () => {
    const { docId } = this.props;
    if (docId && docId !== "add") {
      this.context.redirect(`/workdoc/any/any/${docId}`);
    } else {
      this.context.redirect("/workdoc/");
    }
  };

  renderButtons = () => {
    this.context.actionsSet(
      <>
        <button
          title="Новый"
          onClick={this.new}
          className={`btn btn-icon btn-light mr-2`}
        >
          <i className="fa fa-file-o"></i>
        </button>
        <button
          title="Сохранить"
          onClick={this.save}
          className={`btn btn-icon btn-light mr-2`}
        >
          <i className="fa fa-save"></i>
        </button>
        <button
          title="Открыть"
          onClick={this.open}
          className={`btn btn-icon btn-light mr-2`}
        >
          <i className="fa fa-folder-open-o"></i>
        </button>
      </>
    );
  };

  onElementPickOpen = (idx) => {
    this.setState({ elementPickShow: true, elementPickIdx: idx });
  };

  onElementPickClose = () => {
    this.setState({ elementPickShow: false });
  };

  onElementPick = (elem) => {
    this.onLineChange(this.state.elementPickIdx, "cisternid", elem.id);
    this.onLineChange(this.state.elementPickIdx, "cisternname", elem.label);
  };

  getCisternLabel = (id) => {
    const { cisterns } = this.state;
    if (cisterns[id]) {
      return cisterns[id].name || "";
    }
    return "";
  };

  render() {
    const { item, notFound, pending, lines } = this.state;
    const { docId } = this.props;
    let title = docId === "add" ? "Новая заявка на бункеровку" : item.label;

    if (notFound) {
      title = "Документ не найден";
      return (
        <div className="container">
          <CrumbsProvider title={title} link="/bunkerorder/" />
          <DefaultNotFound />
        </div>
      );
    }

    return (
      <>
        <EssenceReference
          essence="cistern"
          sort="sequence"
          title="Бункеры"
          showDescription
          show={this.state.elementPickShow}
          onHide={this.onElementPickClose}
          onSelect={this.onElementPick}
          itemEditor={(itemEditorProps) => (
            <EssenceReferenceCisternEdit {...itemEditorProps} />
          )}
          extraFields={["shipname"]}
        />
        <CrumbsProvider title={title} link={`/bunkerorder/${item.id}/`} />
        <div className="container h-100">
          <div className="row  h-100">
            <div className="col">
              <div className="card card-custom card-stretch">
                <Blocker on={pending}>
                  <div className="card-body px-5 py-5">
                    <div className="dochat">
                      <div className="flex-grow-1">
                        <div className="row">
                          <div className="col-6">
                            <FormLine label="Судно:">
                              <SuperSelect
                                defaultValue={item.ship}
                                onChange={(value) =>
                                  this.onChange("ship", value)
                                }
                                onSingleItem={(item) =>
                                  this.onChange("ship", item.value)
                                }
                                essence="ship"
                                placeholder="Выберите..."
                                nameField="name"
                                idField="id"
                              />
                            </FormLine>
                          </div>
                          <div className="col-6">
                            <FormLine label="Порт:">
                              <SuperSelect
                                defaultValue={item.harbor}
                                onChange={(value) =>
                                  this.onChange("harbor", value)
                                }
                                essence="harbor"
                                placeholder="Выберите..."
                                nameField="name"
                                idField="id"
                              />
                            </FormLine>
                          </div>
                          <div className="col-12 mt-3">
                            <FormLine label="Комментарий:">
                              <input
                                type="text"
                                value={item.description || ""}
                                onChange={(e) =>
                                  this.onChange("description", e.target.value)
                                }
                                className="form-control"
                              />
                            </FormLine>
                          </div>
                        </div>
                      </div>

                      {item.id && (
                        <div className="d-flex align-items-center ml-3">
                          <EssenceStateLabel
                            onAfterStateChanged={(c) => {
                              if (c === "enabled") {
                                this.open();
                              }
                            }}
                            id={item.id}
                            stateCode={item.statetypecode}
                            stateLabel={item.statelabel}
                            essence="bunker"
                          />
                          <EssenceActionsDropdown
                            essence={"bunker"}
                            key={item.id}
                            id={item.id}
                            label={item.label}
                            onFinish={this.load}
                          />
                        </div>
                      )}
                    </div>
                    <table className="table">
                      <thead>
                        <tr>
                          <th width="50%">
                            <i
                              title="Добавить строку"
                              onClick={() => this.rowAdd()}
                              className="fa fa-plus cursor-pointer text-hover-primary mr-2"
                            ></i>
                            Судовой бункер
                          </th>
                          <th width="15%">Кол-во</th>
                          <th width="15%">Цена</th>
                          <th>Вал.</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lines.map((item, idx) => {
                          let line = item || {};
                          return (
                            <tr key={idx}>
                              <td>
                                <div className="input-group">
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={
                                      this.getCisternLabel(line.cisternid) || ""
                                    }
                                    onDoubleClick={() =>
                                      this.onElementPickOpen(idx)
                                    }
                                    readOnly
                                  />
                                  <div className="input-group-append">
                                    <button
                                      title="Выбрать"
                                      className="btn btn-icon border"
                                      type="button"
                                      onClick={() =>
                                        this.onElementPickOpen(idx)
                                      }
                                    >
                                      <i className="fa icon-md text-muted fa-navicon"></i>
                                    </button>
                                  </div>
                                </div>
                              </td>

                              <td>
                                <input
                                  className="form-control"
                                  value={item.volume || ""}
                                  size={3}
                                  type="number"
                                  onChange={(e) =>
                                    this.onLineChange(
                                      idx,
                                      "volume",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>

                              <td>
                                <input
                                  className="form-control"
                                  value={item.price || ""}
                                  size={3}
                                  type="number"
                                  onChange={(e) =>
                                    this.onLineChange(
                                      idx,
                                      "price",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>

                              <td>
                                <div className="d-flex align-items-center">
                                  <div className="flex-grow-1">
                                    <Select
                                      value={this.context.api.getReferenceValue(
                                        line.currencyid,
                                        this.state.currency
                                      )}
                                      onChange={(result) =>
                                        this.onLineChange(
                                          idx,
                                          "currencyid",
                                          result.value
                                        )
                                      }
                                      className="from-control react-select"
                                      classNamePrefix="react-select-inner"
                                      options={this.state.currency}
                                      placeholder="..."
                                      noOptionsMessage={({ inputValue }) =>
                                        `Ничего не найдено по запросу ${inputValue}`
                                      }
                                    />
                                  </div>
                                  <div className="ml-3 text-nowrap">
                                    <i
                                      title="Удалить строку"
                                      onClick={() => this.rowRemove(idx)}
                                      className="fa fa-times cursor-pointer text-hover-danger "
                                    ></i>
                                    <i
                                      title="Добавить строку ниже"
                                      onClick={() => this.rowAdd(idx + 1)}
                                      className="fa fa-plus cursor-pointer text-hover-primary ml-2"
                                    ></i>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </Blocker>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
